<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="650px" transition="dialog-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="farmer_green" class="mb-4" large dark>Add a product</v-btn>
      </template>

      <!-- Add info icon on every field, for details aka tooltip-->
      <v-form @submit.prevent="onAddProduct" ref="form" v-model="valid">
        <v-card>
          <div v-if="error">
            <app-alert-error class="mb-0" @dismissed="onDismiss" :text="error.message"></app-alert-error>
          </div>
          <v-card-title class="farmer_green white--text">
            <v-row class="mx-1">
              <h4>
                Product Details
              </h4>
              <v-spacer></v-spacer>
              <v-icon class="font-weight-black white--text" @click="dialog = false">clear</v-icon>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="12">
                    <v-text-field color="farmer_green" v-model="title" name="title" label="Title" outlined :rules="fieldRules('Title', 50)" required></v-text-field>
                    <v-text-field color="farmer_green" v-model="category" name="category" label="Category" outlined :rules="fieldRules('Category', 50)" required></v-text-field>
                    <div class="mb-2">
                      <label for="description" class="subtitle-1">Description</label>
                    </div>
                    <div class="mb-4 pb-4">
                      <tiptap-vuetify v-model="description" :card-props="{ flat: true, outlined: true }" :extensions="extensions" placeholder="Description about product..." />
                      <p v-show="descriptionError" class="red--text">
                        {{ descriptionErrorText }}
                      </p>
                    </div>
                    <div class="mb-2">
                      <label for="location" class="subtitle-1">Location</label>
                    </div>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-autocomplete :items="zambia.provinces" v-model="province" class="mr-1" :rules="fieldRules('Province', 50)" label="Province" outlined></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete :items="zambia[province]" v-model="district" :rules="fieldRules('District', 50)" label="District" outlined></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="8" md="6">
                        <v-text-field color="farmer_green" v-model="price" name="price" :label="'Price(ZK)' + '/' + unit" type="number" outlined :rules="fieldRules('Price', 10)" required></v-text-field>
                      </v-col>
                      <v-col cols="4" md="6">
                        <v-autocomplete :items="units" v-model="unit" :rules="fieldRules('Unit', 20)" label="Unit" outlined></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-dialog v-model="unitDialog" persistent max-width="500px" transition="dialog-transition">
                       <v-card>
                         <v-card-title>
                           <v-spacer></v-spacer>
                           <v-icon @click="closeUnitDialog()">clear</v-icon>
                         </v-card-title>
                          <v-row class="mx-0">
                            <v-col cols="8">
                              <v-text-field color="farmer_green" dense v-model="newUnit" name="newUnit" label="Your unit" outlined :rules="fieldRules('Unit', 20)"></v-text-field>
                            </v-col>
                            <v-col cols="4">
                              <v-btn color="primary" @click="onAddUnit" block>Add</v-btn>
                            </v-col>
                          </v-row>
                       </v-card>
                     </v-dialog>
                    <v-btn class="mb-5" color="farmer_green" outlined @click="onPickProductImage">
                      <v-icon left dark>cloud_upload</v-icon> Add an image
                    </v-btn>
                    <input type="file" name="product image" style="display: none" ref="ProductImageInput" accept="image/*" @change="onPickedProductImage" required />
                    <p v-show="imageError" class="red--text">
                      {{ imageErrorText }}
                    </p>

                    <v-img v-if="imageUrl" :src="imageUrl" class="mb-5" max-width="600px" height="auto" rounded></v-img>

                    <p v-show="formError" class="mb-2 red--text">
                      {{ formErrorText }}
                    </p>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed class="grey lighten-2" @click="dialog = false">
              Cancel
            </v-btn>
            <v-btn v-if="!isLoading" depressed class="farmer_green white--text" type="submit">
              Add product
            </v-btn>
            <v-btn v-else depressed type="submit" disabled>
              Submitting...
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import zambia from '../shared/zambia-districts'
import { store } from '@/store'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History
} from 'tiptap-vuetify'

export default {
  components: { TiptapVuetify },
  props: ['supplierId', 'units'],
  data() {
    return {
      dialog: false,
      unitDialog: false,
      isLoading: false,
      title: '',
      description: '',
      zambia: zambia,
      province: '',
      district: '',
      price: '',
      unit: 'Kg',
      newUnit: null,
      originalUnits: [...this.units],
      image: null,
      imageName: '',
      imageUrl: '',
      category: '',
      valid: true,
      descriptionError: false,
      descriptionErrorText: '',
      imageError: false,
      imageErrorText: '',
      formError: false,
      formErrorText: '',
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3]
            }
          }
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak
      ]
    }
  },
  computed: {
    ...mapGetters(['error']),
    fieldRules() {
      return (fieldName, maxChar) => [
        v => (!!v && !!v.trim()) || `${fieldName} is required`,
        v =>
          (v && v.length <= maxChar) ||
          `${fieldName} must be less than ${maxChar} characters`
      ]
    }
  },

  watch: {
    unit(val) {
      if (val === 'Add your unit') this.unitDialog = true
    }
  },

  methods: {
    closeUnitDialog() {
      this.unit = null
      this.unitDialog = false
    },
    onAddUnit() {
      this.unit = this.newUnit
      /** add newUnit to the units, before last position */
      this.units.splice(-1, 0, this.newUnit)
      // this.newUnit = null
      this.unitDialog = false
    },
    onDismiss() {
      store.commit('clearError')
    },
    isDescriptionValid() {
      const descriptionLength = this.description.length
      if (descriptionLength < 1) {
        this.descriptionErrorText = 'Description is required'
        this.descriptionError = true
      } else if (descriptionLength >= 3000) {
        this.descriptionErrorText = 'Description is limited to 3000 characters'
        this.descriptionError = true
      }
      return descriptionLength > 0 && descriptionLength <= 3000
    },
    onPickProductImage() {
      this.$refs.ProductImageInput.click()
    },
    onPickedProductImage() {
      const image = event.target.files[0]
      const imageName = image.name

      if (/\.(png|jpe?g)/i.test(imageName) === false) {
        alert('Please choose a valid image!')
        return
      } else if (imageName.length > 100) {
        alert("The image's name is too long!")
        return
      } else if (image.size > 2097152) {
        return alert('Image size must be less than  2 MB')
      }

      this.image = image
      this.imageName = imageName
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(image)
    },
    onAddProduct() {
      this.isLoading = true
      // check if the image has been added
      if (this.imageName.length < 1) {
        this.imageError = true
        this.imageErrorText = 'Please upload an Image!'
        this.isLoading = false
        return
      }

      // validate description
      if (!this.isDescriptionValid()) {
        this.formError = true
        this.formErrorText = 'Please correct form errors and submit again!'
        this.isLoading = false
        return
      }

      // validate text-field
      if (!this.$refs.form.validate()) {
        this.formError = true
        this.formErrorText = 'Please correct form errors and submit again!'
        this.isLoading = false
        return
      }

      let productDetails = {}

      // if added by admin, include supplierId
      if (this.supplierId) {
        productDetails.supplierId = this.supplierId
      }

      if (!this.originalUnits.includes(this.unit.trim())) {
        productDetails.newUnit = true
      }

      // create the object to be stored in db
      productDetails = {
        ...productDetails,
        title: this.title.trim(),
        description: this.description.trim(),
        price: this.price.trim(),
        unit: this.unit.trim(),
        province: this.province.trim(),
        district: this.district.trim(),
        imageName: this.imageName.trim(),
        category: this.category.trim(),
        image: this.image,
        imageLastModified: this.image.lastModified.toString()
      }

      store
        .dispatch('addProductToSupplierProducts', productDetails)
        .then((status) => {
          if (status === 'success') {
            this.isLoading = false
            this.dialog = false
            this.image = null
            this.imageName = ''
            this.imageUrl = ''
            this.description = ''
            this.descriptionError = false
            this.descriptionErrorText = ''
            this.imageError = false
            this.imageErrorText = ''
            this.formError = false
            this.formErrorText = ''
            this.$refs.form.reset()
            store.commit('clearError')
          } else {
            this.isLoading = false
            store.commit('setError', status)
          }
        })
        .catch(err => {
          this.isLoading = false
          store.commit('setError', err)
        })
    }
  }
}
</script>
